import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsFetching } from '@tanstack/react-query';

import { SkeletonBase } from '@unified-checkout/design-system';

import type {
  INotificationProps,
  TMerchantFlags,
  TNotificationFlags,
} from '@app/dashboard/types/innerLayout/notifications';
import { CONSUMER_NOTIFICATION_OPTIONS } from '@app/dashboard/constants/settings/notifications';
import LabelCardInfo from '@app/dashboard/components/inner_layout/LabelCardInfo';

import ToggleCard from '../shared/ToggleCard';

const ConsumerNotifications = ({
  merchantFlags,
  updatedFlags,
  setUpdatedFlags,
}: INotificationProps) => {
  const { t } = useTranslation();
  const isFetching = useIsFetching();
  const [isTouched, setIsTouched] = useState(false);

  const onToggleChangeHandler = (
    option: TNotificationFlags,
    checked: boolean
  ) => {
    if (!isTouched) return;

    setUpdatedFlags((prev) => ({
      ...(prev as TMerchantFlags),
      [option]: checked,
    }));
  };

  const handleTouchedToggle = () => {
    if (!isTouched) setIsTouched(true);
  };

  const checkToggledValue = (flag: TNotificationFlags) => {
    if (isTouched && updatedFlags && flag in updatedFlags) {
      return updatedFlags[flag as TNotificationFlags];
    }

    return merchantFlags[flag] || false;
  };

  return (
    <LabelCardInfo label={t('innerLayout.notificationsPage.consumers.title')}>
      {CONSUMER_NOTIFICATION_OPTIONS(t).map((option) =>
        !!isFetching ? (
          <SkeletonBase key={option.flag} height="20px" />
        ) : (
          <ToggleCard
            onClickHandler={handleTouchedToggle}
            key={option.flag}
            title={option.title}
            toggleProps={{
              size: 'sm',
              checked: checkToggledValue(option.flag as TNotificationFlags),
              onChangeHandler: (checked) =>
                onToggleChangeHandler(
                  option.flag as TNotificationFlags,
                  checked
                ),
            }}
          />
        )
      )}
    </LabelCardInfo>
  );
};

export default ConsumerNotifications;
